import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"

interface IDynamicReportState {
  dataAdapterDetail: IObjectState<any>
}

export const prefix = "data-adapter/data-adapter"

export const state = (): IDynamicReportState => ({
  dataAdapterDetail: commonObjectState(),
})
export const getters = {
  getDetail: (state: any) => (): any => {
    return { ...(state.dataAdapterDetail.data || {}) }
  },
}

export const mutations = {
  updateDetail: (state: IDynamicReportState, data) => {
    Vue.set(state, "dataAdapterDetail", data)
  },
}

export const actions = {
  getDetail: async ({ commit, state }, data) => {
    const path = `updateDetail`
    try {
      commit(path, ObjectHelper.toLoadingStatus(state.dataAdapterDetail))
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        path,
        ObjectHelper.toObjSuccessStatus(state.dataAdapterDetail, response.data)
      )
    } catch (e: any) {
      commit(
        path,
        ObjectHelper.toErrorStatus(
          state.dataAdapterDetail,
          e.response?.data || e
        )
      )
    }
  },
}
